import { render, staticRenderFns } from "./rightsAndInterests.vue?vue&type=template&id=2a2f56e8&scoped=true&"
import script from "./rightsAndInterests.vue?vue&type=script&lang=js&"
export * from "./rightsAndInterests.vue?vue&type=script&lang=js&"
import style0 from "./rightsAndInterests.vue?vue&type=style&index=0&id=2a2f56e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f56e8",
  null
  
)

export default component.exports